import { NEW_CASE_STATUSES } from '../model';

import type { ActiveCase, NewCase } from '../../types';

export const isNewCase = (caseItem: ActiveCase | NewCase): boolean => {
  if ('oscStatus' in caseItem) {
    return NEW_CASE_STATUSES.includes(caseItem.oscStatus);
  }
  return false;
};
